/**
 * Polyfills for older POS WebViews/browsers.
 *
 * Some tills run on Chrome 88, which predates `Array.prototype.at` /
 * `String.prototype.at` (ES2022, Chrome 92 / Safari 15.4). esbuild does not
 * transpile method calls like `.at()` — only syntax — so the bundle ships them
 * verbatim and they crash with "x.at is not a function" on those devices
 * (see CSN-1324).
 *
 * This module must be imported before any application code runs.
 */

function at(this: { length: number; [index: number]: unknown }, index: number) {
  // Coerce to an integer offset, mirroring the spec.
  let n = Math.trunc(index) || 0;
  if (n < 0) n += this.length;
  if (n < 0 || n >= this.length) return undefined;
  return this[n];
}

const targets: { at?: unknown }[] = [Array.prototype, String.prototype];

// Typed arrays share a hidden prototype; patch it when present.
const TypedArrayProto = Object.getPrototypeOf(Int8Array.prototype) as {
  at?: unknown;
};
if (TypedArrayProto) targets.push(TypedArrayProto);

for (const proto of targets) {
  if (typeof proto.at !== "function") {
    Object.defineProperty(proto, "at", {
      value: at,
      writable: true,
      enumerable: false,
      configurable: true
    });
  }
}

export {};
